<section class="ml-28 mr-8 h-full">
  <div class="grid grid-cols-11 mt-5 mb-4 text-center">
    <label class="ml-4 flex justify-center col-span-1 font-semibold text-base">
      <img [src]="images.suggestions.info" alt="info" class="h-6 w-6 mr-2" />
      {{ literalService.get("suggestions.data.info", true) }}
    </label>
    <label class="flex justify-center col-span-1 font-semibold text-base" [tooltip]="literalService.get('suggestions.data.visibility', true)">
      <img [src]="images.visibility" alt="visibility" class="h-6 w-6 filter-primary-purple-light" />
    </label>
    <label class="flex justify-center col-span-2 font-semibold text-base">
      <img [src]="images.suggestions.affair" alt="title" class="h-6 w-6 mr-2" />
      {{ literalService.get("suggestions.data.affair", true) }}
    </label>
    <label class="flex justify-center col-span-2 font-semibold text-base">
      @if (userType() === CommunicationUserType.DRIVERS) {
        <img [src]="images.suggestions.driver" alt="driver" class="h-6 w-6 mr-2" />
        {{ literalService.get("suggestions.data.driver", true) }}
      }
      @else {
        <img [src]="images.suggestions.user" alt="user" class="h-6 w-6 mr-2" />
        {{ literalService.get("suggestions.data.user", true) }}
      }
    </label>
    <label class="flex justify-center col-span-2 font-semibold text-base">
      <img [src]="images.suggestions.town" alt="town" class="h-6 w-6 mr-2" />
      {{ literalService.get("suggestions.data.town", true) }}
    </label>
    <label class="flex justify-center col-span-1 font-semibold text-base truncate" [tooltip]="literalService.get('suggestions.data.userResolution', true)">
      <img [src]="images.suggestions.status.processed" alt="userResolution" class="h-6 w-6 mr-2 filter-primary-purple-light" />
      {{ literalService.get("suggestions.data.resolution", true) }}
    </label>
    <label class="flex justify-center col-span-1 font-semibold text-base">
      <img [src]="images.suggestions.date" alt="created" class="h-6 w-6 mr-2" />
      {{ literalService.get("suggestions.data.created", true) }}
    </label>
    <label class="flex justify-center col-span-1 font-semibold text-base">
      <img [src]="images.suggestions.date" alt="modified" class="h-6 w-6 mr-2" />
      {{ literalService.get("suggestions.data.modified", true) }}
    </label>
  </div>
</section>
<section>
  <div id="suggestionsContainer" class="scrollable-content h-[calc(100vh-310px)] ml-25 mr-5 px-3 mb-2 overflow-y-scroll" >
    @if(!suggestions()!.isFetchingSuggestion) {
      @for (suggestion of suggestions()!.value; track $index) {
        <a 
          id="{{ `suggestion${suggestion.id}` }}"
          [ngClass]="{'rejected': suggestion.status && suggestion.status.valueOf().toUpperCase() === SuggestionStatus.REJECTED, 'pending': suggestion.status && suggestion.status.valueOf().toUpperCase() === SuggestionStatus.PENDING}"
          class="suggestionRow selectable-row border rounded pt-2 pb-2 grid grid-cols-11 justify-center items-center mb-4"
          [class.selected-row]="suggestion.id === selectedSuggestionId()"
          href="{{ `/suggestions/${suggestion.id}` }}"
          (click)="$event.preventDefault()"
        >
          <div class="flex justify-center cursor-default">
            <div [tooltip]="literalService.get(`suggestions.${suggestion.type!.toLowerCase()}`, true)">
              @switch (suggestion.type) {
                @case (SuggestionTypes.SUGGESTION) {
                  <img [src]="images.suggestions.suggestion" class="h-5 w-5 mr-2" [ngClass]="{'rejected': suggestion.status === SuggestionStatus.REJECTED}" />
                }
                @case (SuggestionTypes.COMPLAINT) {
                  <img [src]="images.suggestions.complaint" class="h-5 w-5 mr-2" [ngClass]="{'rejected': suggestion.status === SuggestionStatus.REJECTED}" />
                }
                @case (DriverSuggestionTypes.INCIDENCE) {
                  <img [src]="images.suggestions.incidence" class="h-5 w-5 mr-2" [ngClass]="{'rejected': suggestion.status === SuggestionStatus.REJECTED}" />
                }
                @case (DriverSuggestionTypes.OBSERVATION) {
                  <img [src]="images.suggestions.observation" class="h-5 w-5 mr-2" [ngClass]="{'rejected': suggestion.status === SuggestionStatus.REJECTED}" />
                }
                @case (SuggestionTypes.OBJECT_LOST) {
                  <img [src]="images.suggestions.objectLost" class="h-5 w-5 mr-2" [ngClass]="{'rejected': suggestion.status === SuggestionStatus.REJECTED}" />
                }
                @case (DriverSuggestionTypes.OBJECT_FOUND) {
                  <img [src]="images.suggestions.objectFound" class="h-5 w-5 mr-2" [ngClass]="{'rejected': suggestion.status === SuggestionStatus.REJECTED}" />
                }
                @default {
                  <img [src]="images.suggestions.complaint" class="h-5 w-5 mr-2" [ngClass]="{'rejected': suggestion.status === SuggestionStatus.REJECTED}" />
                }
              }
            </div>
    
            <div id="prioritiesContainer" class="relative">
              <div class="cursor-pointer" [tooltip]="literalService.get(`suggestions.priorities.${suggestion.priority!.toLowerCase()}`, true)" (click)="togglePriorityModal($event, suggestion.id!)">
                @if (suggestionPriorityIcon(suggestion.priority); as priorityIcon) {
                  <img [src]="priorityIcon.src" class="h-5 w-5 mr-2" [ngClass]="[priorityIcon.filterClass, suggestion.status === SuggestionStatus.REJECTED ? 'rejected' : '']" [alt]="suggestion.priority" />
                }
              </div>
              @if (showPriorityOptions === suggestion.id) {
                <div [id]="`actionsModal-priorities-${suggestion.id}`" class="absolute left-8 w-52 bg-primary-green-2 z-50 rounded-lg py-4 flex flex-col gap-2" [ngClass]="{'-top-16': $index > 1 && $index < suggestions()!.value.length - 2, 'top-0': $index < 2, '-top-36': $index > suggestions()!.value.length - 3}">
                  <button (click)="updatePriority(suggestion.id!, SuggestionPriorities.LOW)" class="flex w-full px-4 py-1 cursor-pointer items-center actionRow text-primary-purple">
                    <img [src]="images.suggestions.priority.low" class="h-6 w-6 mr-2" />
                    <span class="cursor-pointer">{{ literalService.get('suggestions.priorities.low', true) }}</span>
                  </button>
                  <button (click)="updatePriority(suggestion.id!, SuggestionPriorities.MEDIUM)" class="flex w-full px-4 py-1 cursor-pointer items-center actionRow text-primary-purple">
                    <img [src]="images.suggestions.priority.medium" class="h-6 w-6 mr-2" />
                    <span class="cursor-pointer">{{ literalService.get('suggestions.priorities.medium', true) }}</span>
                  </button>
                  <button (click)="updatePriority(suggestion.id!, SuggestionPriorities.HIGH)" class="flex w-full px-4 py-1 cursor-pointer items-center actionRow text-primary-purple">
                    <img [src]="images.suggestions.priority.high" class="h-6 w-6 mr-2" />
                    <span class="cursor-pointer">{{ literalService.get('suggestions.priorities.high', true) }}</span>
                  </button>
                  <button (click)="updatePriority(suggestion.id!, SuggestionPriorities.HIGHEST)" class="flex w-full px-4 py-1 cursor-pointer items-center actionRow text-primary-purple">
                    <img [src]="images.suggestions.priority.highest" class="h-6 w-6 mr-2" />
                    <span class="cursor-pointer">{{ literalService.get('suggestions.priorities.highest', true) }}</span>
                  </button>
                </div>
              }
            </div>
    
            <div id="statusesContainer" class="relative">
              <div [tooltip]="literalService.get(`suggestions.statuses.${suggestion.status!.toLowerCase()}`, true)" (click)="toggleStatusModal($event, suggestion.id!)">
                <img [src]="suggestionStatusIcon(suggestion.status).src" class="h-5 w-5 mr-2" [ngClass]="suggestionStatusIcon(suggestion.status).filterClass" [alt]="suggestion.status" />
              </div>
              @if (showStatusOptions === suggestion.id) {
                <div [id]="`actionsModal-statuses-${suggestion.id}`" class="absolute left-8 w-52 bg-primary-green-2 z-50 rounded-lg py-4 flex flex-col gap-2" [ngClass]="{'-top-16': $index > 1 && $index < suggestions()!.value.length - 2, 'top-0': $index < 2, '-top-36': $index > suggestions()!.value.length - 3}">
                  <button (click)="updateStatus(suggestion.id!, SuggestionStatus.PENDING)" class="flex w-full px-4 py-1 cursor-pointer items-center actionRow text-primary-purple">
                    <img [src]="images.suggestions.status.pending" class="h-6 w-6 mr-2" />
                    <span class="cursor-pointer">{{ literalService.get('suggestions.statuses.pending', true) }}</span>
                  </button>
                  <button (click)="updateStatus(suggestion.id!, SuggestionStatus.IN_PROGRESS)" class="flex w-full px-4 py-1 cursor-pointer items-center actionRow text-primary-purple">
                    <img [src]="images.suggestions.status.inProgress" class="h-6 w-6 mr-2" />
                    <span class="cursor-pointer">{{ literalService.get('suggestions.statuses.in_progress', true) }}</span>
                  </button>
                  <button (click)="updateStatus(suggestion.id!, SuggestionStatus.PROCESSED)" class="flex w-full px-4 py-1 cursor-pointer items-center actionRow text-primary-purple">
                    <img [src]="images.suggestions.status.processed" class="h-6 w-6 mr-2" />
                    <span class="cursor-pointer">{{ literalService.get('suggestions.statuses.processed', true) }}</span>
                  </button>
                  <button (click)="updateStatus(suggestion.id!, SuggestionStatus.REJECTED)" class="flex w-full px-4 py-1 cursor-pointer items-center actionRow text-primary-purple">
                    <img [src]="images.suggestions.status.rejected" class="h-6 w-6 mr-2" />
                    <span class="cursor-pointer">{{ literalService.get('suggestions.statuses.rejected', true) }}</span>
                  </button>
                </div>
              }
            </div>
          </div>
          <div class="flex justify-center cursor-pointer" (click)="showSuggestionData(suggestion.id!)">
            <img [src]="suggestionVisibilityIcon(suggestion.visibility)" [alt]="suggestion.visibility ?? 'PRIVATE'" class="h-5 w-5 filter-primary-purple"
              [tooltip]="visibilityTooltip(suggestion)" [position]="TooltipPosition.DYNAMIC" />
          </div>
          <label [id]="`name-${suggestion.id}`" class="truncate pr-3 pl-3 col-span-2 text-base cursor-pointer" [tooltip]="utilsService.visibleTooltip(`name-${suggestion.id}`) ? literalService.get('suggestions.affairs.' + suggestion.affair, true) : ''" [visibleTooltip]="utilsService.visibleTooltip(`name-${suggestion.id}`)" [position]="TooltipPosition.DYNAMIC" (click)="showSuggestionData(suggestion.id!)">
            {{ literalService.get('suggestions.affairs.' + suggestion.affair, true)}}
          </label>
          <label [id]="`user-${suggestion.id}`" class="truncate pr-3 pl-3 col-span-2 text-base cursor-pointer" [tooltip]="(utilsService.visibleTooltip(`user-${suggestion.id}`) && suggestion.userSuggester?.id) ? getUserSuggesterName(suggestion) : ''" [visibleTooltip]="utilsService.visibleTooltip(`user-${suggestion.id}`)" [position]="TooltipPosition.DYNAMIC" (click)="showSuggestionData(suggestion.id!)">
            {{ getUserSuggesterName(suggestion) }}
          </label>
          <label [id]="`town-${suggestion.id}`" class="truncate pr-3 pl-3 col-span-2 text-base cursor-pointer" [tooltip]="(utilsService.visibleTooltip(`town-${suggestion.id}`) && suggestion.town) ? suggestion.town.name! : ''" [visibleTooltip]="utilsService.visibleTooltip(`town-${suggestion.id}`)" [position]="TooltipPosition.DYNAMIC" (click)="showSuggestionData(suggestion.id!)">
            {{ suggestion.town?.name || '-' }}
          </label>
          <div class="flex justify-center col-span-1 cursor-pointer" (click)="showSuggestionData(suggestion.id!)">
            @if (suggestion.userResolution) {
              <span class="badge badge-sm whitespace-nowrap truncate" [ngClass]="suggestionUserResolutionBadgeClass(suggestion.userResolution)">
                {{ literalService.get('suggestions.userResolutions.' + suggestion.userResolution, true) }}
              </span>
            } @else {
              -
            }
          </div>
          <label [id]="`creation-${suggestion.id}`" class="truncate pr-3 pl-3 col-span-1 text-base cursor-pointer" (click)="showSuggestionData(suggestion.id!)">
            {{ suggestion.createdAt | date: 'yyyy-MM-dd' }}
          </label>
          <label [id]="`lastModification-${suggestion.id}`" class="truncate pr-3 pl-3 col-span-1 text-base cursor-pointer" (click)="showSuggestionData(suggestion.id!)">
            {{ (suggestion.lastModifiedAt | date: 'yyyy-MM-dd') || '-' }}
          </label>
        </a>
      }
    } @else {
      <ngx-skeleton-loader [count]="suggestions()?.pagination?.size || 10" appearance="line" [theme]="{ 'height': '40px' }"></ngx-skeleton-loader>
    }
  </div>
</section>